import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$3 } from './custom-popper2.js';
import { d as defineCustomElement$2 } from './form-control-error-text2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const FileInput = /*@__PURE__*/ proxyCustomElement(class FileInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.fileSelected = createEvent(this, "fileSelected", 7);
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            this.inputHandler(name, target.value);
            this.formControlInput.emit({ name, value: target.value });
        };
        this.changeHandler = () => {
            const inputFileList = this.fileInput.files;
            if (inputFileList) {
                this.fileSelected.emit({
                    fileList: inputFileList,
                    document_type: this.documentType
                });
            }
        };
        this.files = undefined;
        this.fileString = undefined;
        this.label = undefined;
        this.name = undefined;
        this.helpText = undefined;
        this.errorText = undefined;
        this.multiple = undefined;
        this.documentType = undefined;
        this.inputHandler = undefined;
        this.disabled = undefined;
    }
    componentDidLoad() {
        this.fileInput = this.el.querySelector('input');
    }
    render() {
        return (h(Host, { key: 'd3928cd6013d8e1bd23921a3d73b57de3a3f4c8f', exportparts: "label,input,input-invalid" }, h("div", { key: '5c15b542801ed84a4bdd43b7a7cb8f9a70ab5016', class: "form-group d-flex flex-column" }, h("div", { key: '1636d3a16f0da8047361cbaa87423d35e042de40', class: "d-flex align-items-start gap-2" }, h("label", { key: 'bfce95a71327cf8dd69aee4de8f1ff72c2ddcd97', part: "label", class: "form-label", htmlFor: this.name }, this.label), h("form-control-tooltip", { key: '2f6167da52618938b39e3917332a74ac3c19aba0', helpText: this.helpText })), h("input", { key: '1b06c50ddb2c1bec731ceca89cc2a19a7329e3cd', ref: (el) => this.fileInput = el, type: "file", name: this.name, part: `input ${this.errorText ? "input-invalid " : ""}${this.disabled ? "input-disabled" : ""}`, class: this.errorText ? "form-control is-invalid" : "form-control", multiple: this.multiple, disabled: this.disabled, onChange: this.changeHandler, onInput: this.handleFormControlInput, onBlur: () => this.formControlBlur.emit() }), h("form-control-error-text", { key: '0f38dc541504c11d49afda08f5531d9612e4911d', errorText: this.errorText, name: this.name }))));
    }
    get el() { return this; }
}, [0, "form-control-file", {
        "label": [1],
        "name": [8],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "multiple": [4],
        "documentType": [1, "document-type"],
        "inputHandler": [16],
        "disabled": [4],
        "files": [32],
        "fileString": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-file", "custom-popper", "form-control-error-text", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-file":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, FileInput);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { FileInput as F, defineCustomElement as d };
